import type { Message } from '@/features/messages/models/message';
import { Divider, Menu } from '@mui/material';
import type { FC } from 'react';
import { MesageMenuCopyItem } from './message-menu-copy-item';
import { MessageMenuDateDisplay } from './message-menu-date-display';
import { MesageMenuDeleteItem } from './message-menu-delete-item';
import { ForwardMenuItem } from './message-menu-forward-item';
import { PinedMenuItem } from './message-menu-pined-item';
import { ReplyMenuItem } from './message-menu-reply-item';
import { MessageMenuSeenBy } from './message-menu-seen-by';

interface MessageContextMenuProps {
  isOwn: boolean;
  contextMenu: { mouseX: number; mouseY: number } | null;
  selMsg: Message | null;
  onClose: () => void;
}

export const MessageMenu: FC<MessageContextMenuProps> = ({ isOwn, contextMenu, selMsg, onClose }) => {
  if (!selMsg) {
    return null;
  }

  return (
    <Menu
      open={contextMenu !== null}
      onClose={onClose}
      onContextMenu={(event) => event.preventDefault()}
      anchorReference='anchorPosition'
      anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
    >
      <MesageMenuCopyItem message={selMsg} onClose={onClose} />
      <PinedMenuItem msg={selMsg} onClose={onClose} />
      <ReplyMenuItem msg={selMsg} onClose={onClose} />
      <ForwardMenuItem msg={selMsg} onClose={onClose} />
      <MesageMenuDeleteItem isOwn={isOwn} msg={selMsg} onClose={onClose} scopeChoice='Everyone' />
      <MesageMenuDeleteItem isOwn={isOwn} msg={selMsg} onClose={onClose} scopeChoice='Me' />
      <Divider />
      <MessageMenuSeenBy message={selMsg} />
      <MessageMenuDateDisplay message={selMsg} />
      {/* <DeleteMenuItem message={selectedMessage} onClose={onClose} /> */}
    </Menu>
  );
};
